import { styled } from '@linaria/react';

import { space } from '../theme/tokens';

export const CloseIconSlot = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${space['space-600']};
  height: ${space['space-600']};
`;
